<template>
    <v-tooltip top v-model="show">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                :x-small="xSmall"
                :color="color"
                class="align-center"
                v-bind="attrs"
                @click.stop="copyToClipboard()"
            >
                <v-icon :x-small="xSmall">{{ icon }}</v-icon></v-btn
            >
        </template>
        <div class="flex">
            <v-icon :x-small="xSmall" left color="white">check</v-icon>Copied
        </div></v-tooltip
    >
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: "content_paste",
        },
        xSmall: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "dark",
        },
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.text);
            this.show = true;
            setTimeout(() => {
                this.show = false;
            }, 600);
        },
    },
};
</script>
